export default {
    navbar: {//头部信息
        welcomes: 'welcome to use',
        companyName: 'Olindel Mall',
		switch:'Language',
		login:'log on',
		quit:'Log out of login',
		registration:'Free registration',
		homePage:'home page',
		personal:'Personal Center',
		contactService:'contact service',
		mobile:'Mobile version',
		myCart:'my cart',
		search:'search for',
		contentSearch:'Please enter content search',
		homepage:'homepage',
		siteActions:'Please log in to the app or scan the code to access the mobile website for operation',
    },
	foots:{//底部信息
		customerService:'PHONE',
		contactAddress:'Contact address',
		QRcode:'Scan QR code',
		obtain:'Obtain high-quality products across the entire network',
		operatedMallApp:'Download the self operated mall app',
		copyright:'Copyright',
		
	},
	commodity:{//商品页面数据信息
		sort:'sort',
		none:'There is currently no data available',
		groupBuying:'Group buying',
		collect:'Collect products',
		deliveryPrice:'Delivery price',
		share:'Sharing and earning',
		salesVolume:'Sales volume',
		monthlySales:'Monthly sales',
		quantity:'Quantity',
		buyNow:'BUY NOW',
		shoppingCart:'Add to shopping cart',
		show:'Product display',
		comment:'All comments',
		user:'user',
		characters:'Descriptive text',
	},
	personal:{//个人中心
		homePage:'home page',
		account:'Account Settings',
		orderCenter:'Order Center',
		myOrder:'My Order',
		afterSales:'Return/After Sales',
		address:'Address',
		focusCenter:'Focus Center',
		myCollection:'My Collection',
		myFootprint:'My footprint',
		assetCenter:'Asset Center',
		myWallet:'my wallet',
		myPoints:'My points',
		discountCoupon:'Discount coupon',
		allOrders:'All Orders',
		obligation:'obligation',
		toBeShipped:'To be shipped',
		goodsToBeReceived:'Goods to be received',
		toBeUsed:'To be used',
		toBeEvaluated:'To be evaluated',
		canceled:'Canceled',
		refunding:'refunding',
		refunded:'Refunded',
		refuseRefund:'Refuse Refund',
		inAGroup:'In a group',
		evaluated:'Evaluated',
		babyInformation:'Cargo Information',
		unitPrice:'Unit price',
		yuan:'yuan',
		dollar:'dollar',
		number:'number',
		disbursements:'Disbursements',
		transactionStatus:'Transaction Status',
		transactionOperations:'Transaction Operations',
		orderNumber:'Order Number',
		productSpecifications:'Product specifications',
		orderDetails:'Order details',
		cancellationOfOrder:'cancellation of order',
		ReasonForCancellation:'Reason for cancellation',
		PleaseEnterTheReasonForCancellation:'Please enter the reason for cancellation',
		refund:'refund',
		ReasonForRefund:'Reason for refund',
		PleaseEnterTheRefundReason:'Please enter the refund reason',
		toPay:'confirm an order',
		reminderShipment:'Reminder shipment',
		confirmReceipt:'Confirm receipt',
		toEvaluate:'To evaluate',
		deleteOrder:'Delete Order',
		payAmount:'Pay Amount',
		refundAmount:'refund amount',
		orderTime:'Order time',
		refundStatus:'Refund status',
		savedShippingAddress:'Saved shipping address',
		phone:'phone',
		createANewShippingAddress:'Create a new shipping address',
		consignee:'consignee',
		phoneNumber:'cell-phone number',
		province:'Provincial and urban areas',
		setAsDefaultAddress:'Set as default address',
		save:'save',
		myBalance:'My Balance',
		withdrawableAmount:'Withdrawable amount',
		accumulatedWithdrawalAmount:'Accumulated withdrawal amount',
		walletDetails:'Wallet details',
		withdrawalRecords:'Withdrawal records',
		typesOf:'types of',
		content:'content',
		time:'time',
		amountOfMoney:'amount of money',
		nameOfAlipay:'Name of Alipay',
		alipayAccount:'Alipay account',
		state:'state',
		withdrawing:'Withdrawing',
		withdrawalSuccessful:'Withdrawal successful',
		withdrawalFailed:'Withdrawal failed',
		pointsDetails:'Points Details',
		productVoucher:'Product voucher',
		universalCoupon:'Universal coupon',
		name:'name',
		fullReduction:'Full reduction',
		periodOfValidity:'period of validity',
		full:'full',
		available:'available',
		validTo:'valid to',
		pleaseSelectACity:'Please select a city',
		cancellation:'cancellation',
		Confirm:'Confirm',
		PaymentBox:'confirm the payment',
		
	},
	orderDetails:{//订单详情
		takeAProduct:'Take a product',
		paymentSuccessful:'Payment successful',
		sellerShipping:'Seller Shipping',
		commodityInformation:'commodity information',
		putAway:'put away',
		discountAmount:'Discount amount',
		totalAmountOfGoods:'Total amount of goods',
		totalFreightCost:'Total freight cost',
		logisticsInformation:'Logistics information',
		noLogisticsInformationAvailable:'There is currently no logistics information available',
		notes:'notes',
		allProducts:'All products',
		delete:'delete',
		selectAll:'Select All',
		amountTo:'amount to',
		ommediateClosure:'Immediate closure',
		operate:'operate',
		trackingNumber:'tracking number',
		VehicleImage:'Vehicle image',
		ReasonForRejection:'Reason for rejection',
		ReasonForRefundRequest:'Reason for Refund Request',
	},
	personalInformation:{//个人信息
		memberUsers:'User nickname',
		pleaseEnterANickname:'Please enter a nickname',
		gender:'gender',
		schoolgirl:'schoolgirl',
		schoolboy:'schoolboy',
		modifyPhoneNumber:'Modify phone number',
		withdrawalAccount:'Withdrawal account',
		setUp:'Set up a withdrawal account to facilitate withdrawal services',
		setUpWithdrawalAccount:'Set up withdrawal account',
		CUSTOMERSERVICE:'CUSTOMER SERVICE',
		CreationTime:'Creation time',
		sendFiles:'send files',
		PleaseEnterContent:'Please enter content',
		sending:'sending',
		
	},
	paymentPage:{//支付页面
		consigneeInformation:'Consignee Information',
		newlyFilledDeliveryAddress:'Newly filled delivery address',
		addressInformation:'There is currently no address information available. Please add the address information',
		freight:'Freight (yuan)',
		leaveAMessage:'Leave a message to the seller',
		specialNeeds:'You can tell the seller your special needs and need to negotiate with them',
		paymentAccount:'Payment account',
		enterYourPaymentAccount:'Please enter your payment account',
		PaymentScreenshot:'Payment screenshot',
		sentTo:'Sent to',
		submitOrder:'submit order',
		CommentContent:'Comment content',
		score:'score',
		Pictures:'Pictures',
		PleaseFillInTheCommentContent:'Please fill in the comment content',
		comment:'comment',
		
	},
	login:{//登录页面
		WeChatQRCodeLogin:'WeChat QR code login',
		welcomeToRegister:'Welcome to register',
		existingAccount:'Existing account',
		logOn:'log on',
		mobileAndEmail:'Mobile phone number/email',
		password:'password',
		forgotPassword:'forgot password',
		register:'register',
		enterYourPhoneNumber:'Please enter your phone number',
		enterTheVerificationCode:'Please enter the verification code',
		obtainVerificationCode:'Obtain verification code',
		reacquireInSeconds:'Reacquire in seconds',
		toScanAndLogIn:'Please use WeChat to scan and log in',
		passwordLogin:'Password login',
		registerAnAccount:'Register an account',
		pleaseSetLoginPassword:'Please set login password',
		readAndAccept:'Read and accept',
		UserAgreement:'User Agreement',
		asWellAs:'as well as',
		privacyProtectionStatement:'Privacy Protection Statement',
		submitTo:'submit to',
		pleaseSetTheUsername:'Please set the username',
		
		
	},
}


// WEBPACK FOOTER //
// ./src/lang/en.js